<script lang="ts" setup>
interface Item {
  label: string;
  content: string;
  options?: string[];
}

const props = defineProps<{
  title: string;
  items: Item[];
}>();
</script>

<template>
  <UContainer class="contract-term">
    <UCard
      class="my-4"
      data-test="terms-conditions"
      :ui="{ header: { base: 'bg-card-contrast rounded-t-lg' } }"
    >
      <template #header>
        <h1
          class="text-2xl font-semibold"
          data-test="title"
        >
          {{ props.title }}
        </h1>
      </template>

      <div
        v-for="(item, index) of props.items"
        :key="index"
        class="flex flex-col"
        data-test="item"
      >
        <h2
          class="text-2xl"
          :class="{ 'pb-10': index === 0, 'py-10': index > 0 }"
          data-test="item-label"
        >
          {{ item.label }}
        </h2>

        <h3>
          <p
            class="text-sm leading-7"
            data-test="item-content"
          >
            {{ item.content }}
          </p>
        </h3>

        <ul
          v-if="item.options"
          class="pt-5 text-sm leading-7"
          data-test="item-options"
        >
          <li
            v-for="(option, i) of item.options"
            :key="i"
          >
            <h4 data-test="item-option">
              {{ option }}
            </h4>
          </li>
        </ul>
      </div>
    </UCard>
  </UContainer>
</template>

<style lang="scss" scoped>
.contract-term {
  padding-top: var(--header-height);

  ul {
    list-style-type: circle;
    list-style-position: inside;
  }
}
</style>
